import {environment} from "environments";

// this is a controller because UI router is not updated to allow
// angularjs component architecture - seeing as we are migrating
// to the latest angular there's no point making old code conventions
class BatchingRules {
  constructor($window, Batching, $timeout, ngDialog, $scope) {
    Object.assign(this, {
      $window,
      Batching,
      $timeout,
      ngDialog,
      $scope,
      newRulesList: [],
      showForm: false,
      showHelper: false,
      rulePlaceholder: {
        service: '',
        product: '',
        rule: '',
        params: '',
      },
      batchingRulesData: [],
      batchingRules: {
        serviceOpts: [],
        productOpts: [],
        ruleOpts: [],
        paramsOpts: []
      },
      selected: {
        service: [],
        product: [],
        rule: [],
        params: []
      },
      selectedIds: [],
      ruleRow: null,
    });
  }

  $onInit() {
    this.filtersData();
  }

  // Helper: Build unique dropdown options for a filter, marking selected (ticked) options
  buildUniqueOptions(records, propertyName, selectedSet = new Set()) {
    const map = new Map();
    records.forEach(record => {
      map.set(record[propertyName], {
        id: record.id,
        [propertyName]: record[propertyName],
        ticked: selectedSet.has(record[propertyName])
      });
    });
    return Array.from(map.values());
  }

  filtersData() {
    this.Batching.getBatchRules()
      .then((rulesResponse) => {
        this.batchingRulesData = rulesResponse;
        this.batchingRules.serviceOpts = this.buildUniqueOptions(rulesResponse, 'service');
        this.batchingRules.productOpts = this.buildUniqueOptions(rulesResponse, 'product');
        this.batchingRules.ruleOpts    = this.buildUniqueOptions(rulesResponse, 'rule');
        this.batchingRules.paramsOpts  = this.buildUniqueOptions(rulesResponse, 'params');
      })
      .catch((error) => {
        console.log('Failed to fetch batching rules:', error);
      });
  }

  filterApply(activeFilterName) {
    return this.$timeout(() => {
      const filterKeys = Object.keys(this.selected);

      const extract = (arr, key) =>
        Array.isArray(arr) ? arr.map(item => (item && typeof item === 'object' ? item[key] : item)) : [];

      const selectedSets = {};
      filterKeys.forEach(key => {
        selectedSets[key] = new Set(extract(this.selected[key], key));
      });

      const filteredRecords = this.batchingRulesData.filter(rule =>
        filterKeys.every(
          key => !selectedSets[key].size || selectedSets[key].has(rule[key])
        )
      );

      // Use the shared buildUniqueOptions helper
      filterKeys.forEach(key => {
        if (key !== activeFilterName) {
          this.batchingRules[`${key}Opts`] = this.buildUniqueOptions(filteredRecords, key, selectedSets[key]);
        }
      });

      const validSets = {};
      filterKeys.forEach(key => {
        validSets[key] = new Set(filteredRecords.map(rule => rule[key]));
      });
      filterKeys.forEach(key => {
        if (key !== activeFilterName) {
          this.selected[key] = this.selected[key].filter(
            item => validSets[key].has((item && item[key]) || item)
          );
        }
      });

      if (this.allFiltersEmpty()) {
        filterKeys.forEach(key => {
          this.batchingRules[`${key}Opts`] = this.buildUniqueOptions(this.batchingRulesData, key, new Set());
        });
        this.selectedIds = [];
        return;
      }

      this.selectedIds = [...new Set(filteredRecords.map(rule => rule.id))];
    }, 0);
  }

  resetApply() {
    Object.keys(this.batchingRules).forEach(optionGroupKey =>
      this.batchingRules[optionGroupKey].forEach(optionItem => (optionItem.ticked = false))
    );
    Object.keys(this.selected).forEach(filterKey => (this.selected[filterKey].length = 0));
    this.filterApply(null).then(() => {
      this.selectedIds = [];
    });
  }

  selectNoneApply(filterKey) {
    this.selected[filterKey].length = 0;
    this.filterApply(filterKey);
    if (this.allFiltersEmpty()) {
      this.resetApply();
      angular.element(document).triggerHandler('click');
    }
  }

  allFiltersEmpty() {
    return Object.values(this.selected).every(arr => arr.length === 0);
  }

  openBatchingRuleDialog(rule) {
    this.ruleRow = rule;
    let modalTitle = typeof rule === 'string' && rule === 'add' ? 'Add Rule' : 'Edit Rule';

    const dialog = this.ngDialog.open({
      scope: this.$scope,
      plain: true,
      className: 'ngdialog-theme-default ngdialog-draggable ngdialog-large batching-rule-dialog',
      template: `<div class="modal-header"><h3>${modalTitle}</h3></div>
                 <div class="modal-body">
                    <add-batching-rule-form
                      parent="vm"
                      row="vm.ruleRow"
                      rule-placeholder="vm.rulePlaceholder"
                      on-save="vm.addBatchRules(rules)">
                    </add-batching-rule-form>
                 </div>`,
    });

    dialog.closePromise.then(() => {
      if (typeof rule !== 'string' && rule.editing) { rule.editing = false; }
    });

    setTimeout(() => {
      $('.ngdialog-draggable .ngdialog-content').draggable({ handle: '.modal-header, .modal-body' });
    }, 200);

    this.$scope.$on('$locationChangeStart', () => dialog.close());

  }

  addBatchRules(rules) {
    this.newRulesList = [
      ...rules,
    ];
  }

  populateAddBatchRulesForm(rule) {
    this.rulePlaceholder = {
      service: rule.service,
      product: rule.product,
      rule: rule.rule,
      params: rule.params,
    };
    this.$window.scrollTo(0, angular.element('put here your element').offsetTop);
  }

  saveBatchingRule(rule) {
    this.$scope.$broadcast('saveBatchingRule', rule);
  }

  deleteBatchingRule(rule) {
    this.$scope.$broadcast('deleteBatchingRule', rule);
  }

}

BatchingRules.$inject = ['$window', 'Batching', '$timeout', 'ngDialog', '$scope'];
angular.module('pims').controller('BatchingRules', BatchingRules);
